import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { Tablev2Component } from '../tablev2/tablev2.component';

@Component({
  selector: 'app-voucher-usage-random',
  templateUrl: './voucher-usage-random.component.html',
  styleUrls: ['./voucher-usage-random.component.scss']
})
export class VoucherUsageRandomComponent implements AfterViewInit {

  public company_uuid;
  @ViewChild("table", { static: false }) tb: Tablev2Component;

  constructor(private http: HttpService, private cdr : ChangeDetectorRef) {
    this.http.getSelectedCompany().subscribe(val => {
      this.company_uuid = val;
    });
   }

  ngAfterViewInit(): void {
      this.init();
  }

  async init() {
    const setting = 
        { post: {url: "/admin/app/voucher/usage", data: {page_nat: true, uuid: this.company_uuid}},
          disabled_pagenat: false,
          fields: [
            {label: 'No', type: 'index'}, 
            {label: 'Voucher Code', type: 'string', key: 'voucher_code', filter: "string"}, 
            {label: 'Player Code', type: 'string', key: 'player_code', filter: "string"}, 
            {label: 'Winning', type: 'string', key: 'winning', filter: "string"}, 
            {label: 'Claim On', type: 'claim_voucher', action: this.action, key: 'claim'}, 
            {label: 'Draw On', type: 'timestamp', key: 'create_on'}, 
            {label: 'Delete', type: 'delete', key: 'uuid', table: 'player_voucher', title: 'voucher_code', hide: true},
          ]}
      this.tb.init(setting);
      
  }

  public action = async (data:any) => {
    await this.http.post("/admin/app/voucher/claim", {voucher_uuid: data.uuid});
    this.init();
  }

}
